import {
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_FAILED,
  INGESTION_SUCCESS,
  INGESTION_FAILED,
  ADDED_FILE_ID_TO_REDUX,
  IS_INGESTING,
  INGESTION_STATE_RESET,
  ALL_KNOWLEDGE_BASE_STATE_RESET,
  GET_FILES_SUCCESS,
  GET_FILES_FAILED,
  FOLDER_UPLOAD_SUCCESS,
  FOLDER_UPLOAD_FAILED,
  FOLDER_INGESTION_SUCCESS,
  FOLDER_INGESTION_FAILED,
  IS_FOLDER_INGESTING,
  FOLDER_INGESTION_STATE_RESET,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILED,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAILED,
  REPLACE_DOCUMENT_SUCCESS,
  REPLACE_DOCUMENT_FAILED,
} from "../Actions/Types";

const initialState = {
  fileUploaded: null,
  file: null,
  Ingested: null,
  fileID: null,
  isIngesting: false,
  folderUploaded: null,
  folder: null,
  folderIngested: null,
  folderID: null,
  isFolderIngesting: false,
  files: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  fileDeleted: null,
  documentDeleted: null,
  documentReplaced: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        file: action.payload,
        fileUploaded: true,
      };
    case FILE_UPLOAD_FAILED:
      return {
        ...state,
        file: null,
        fileUploaded: false,
      };
    case INGESTION_SUCCESS:
      return {
        ...state,
        Ingested: true,
      };
    case INGESTION_FAILED:
      return {
        ...state,
        Ingested: false,
      };
    case ADDED_FILE_ID_TO_REDUX:
      return {
        ...state,
        fileID: action.payload,
      };
    case IS_INGESTING:
      return {
        ...state,
        isIngesting: action.payload,
      };
    case INGESTION_STATE_RESET:
      return {
        ...state,
        Ingested: null,
      };
    case FOLDER_UPLOAD_SUCCESS:
      return {
        ...state,
        folder: action.payload,
        folderUploaded: true,
        folderID: action.payload.file_id,
      };
    case FOLDER_UPLOAD_FAILED:
      return {
        ...state,
        folder: null,
        folderUploaded: false,
        folderID: null,
      };
    case FOLDER_INGESTION_SUCCESS:
      return {
        ...state,
        folderIngested: true,
      };
    case FOLDER_INGESTION_FAILED:
      return {
        ...state,
        folderIngested: false,
      };
    case IS_FOLDER_INGESTING:
      return {
        ...state,
        isFolderIngesting: action.payload,
      };
    case FOLDER_INGESTION_STATE_RESET:
      return {
        ...state,
        folderIngested: null,
      };
    case ALL_KNOWLEDGE_BASE_STATE_RESET:
      return {
        ...state,
        fileUploaded: action.payload,
        file: action.payload,
        Ingested: action.payload,
        fileID: action.payload,
        isIngesting: action.payload,
        folderUploaded: action.payload,
        folder: action.payload,
        folderIngested: action.payload,
        folderID: action.payload,
        isFolderIngesting: action.payload,
      };
    case GET_FILES_SUCCESS:
      return {
        ...state,
        files: action.payload,
      };
    case GET_FILES_FAILED:
      return {
        ...state,
        files: {
          count: 0,
          next: null,
          previous: null,
          results: [],
        },
      };
    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        fileDeleted: true,
        files: {
          ...state.files,
          results: state.files.results.filter((f) => f.id !== action.payload),
          count: state.files.count - 1,
        },
      };
    case DELETE_FILE_FAILED:
      return { ...state, fileDeleted: false };
    case DELETE_DOCUMENT_SUCCESS:
      return { ...state, documentDeleted: true };
    case DELETE_DOCUMENT_FAILED:
      return { ...state, documentDeleted: false };
    case REPLACE_DOCUMENT_SUCCESS:
      return { ...state, documentReplaced: true };
    case REPLACE_DOCUMENT_FAILED:
      return { ...state, documentReplaced: false };
    default:
      return state;
  }
}
